import React, { useMemo } from 'react';
import { FilterSelect, FilterSelectOption } from '../inputs/filter-select';
import { useServerSideDatatable } from '../serverside-datatable';
import { Sprite } from '../sprite';

interface Props {}

export const GiftFilterer: React.FC<Props> = () => {
  const {
    searchBarPlaceholder,
    currentPage,
    setSearchTerm,
    setFilterByValue,
    filterByValue,
    setFilterByField,
    query,
  } = useServerSideDatatable();

  const statusOptions = useMemo<FilterSelectOption[]>(
    () =>
      ['New', 'Gift Redeemed'].map(value => ({
        value: value.toUpperCase(),
        label: value,
      })),
    [],
  );

  return (
    <div className="flex flex-row mb-4">
      <div className="flex-1">
        <div className="relative">
          <div className="absolute top-0 pl-[14.5px] h-full flex flex-col justify-center z-[2] pointer-events-none">
            <Sprite
              name="icon-search"
              className="w-[20px] h-[20px] text-gray fill-gray"
            />
          </div>
          <input
            type="text"
            className="border border-gray-medium rounded-md pl-[40px] py-2 pr-2 placeholder:text-gray relative z-[1] w-full bg-white"
            placeholder={searchBarPlaceholder}
            onChange={event => setSearchTerm(event.currentTarget.value)}
          />
        </div>
      </div>
      <div className="flex-1 flex flex-row justify-end pl-16">
        <div className="flex-1 flex flex-row justify-end">
          <div className="w-auto">
            <FilterSelect
              currentValue={filterByValue}
              placeholder="All"
              options={statusOptions}
              onChange={value => {
                setFilterByField(value ? 'status' : '');
                setFilterByValue(value);
              }}
              icon={
                <Sprite
                  name="icon-caret"
                  className="w-[20px] h-[20px] text-gray fill-gray"
                />
              }
            />
          </div>
        </div>
        <div className="pl-3">
          <button
            type="button"
            onClick={() => query({ page: currentPage })}
            className="px-4 py-2 border-[2px] border-white bg-white shadow-[0px_1px_1px_rgba(0,0,0,0.06)] active:shadow-none rounded-[5px] font-semibold text-blue">
            Refresh
          </button>
        </div>
      </div>
    </div>
  );
};
